<template>
  <main class="main">
    <section class="flex-1 my-10 pb-20">
      <div class="text-center px-5">
        <h1 class="font-medium mb-3 pt-20">로그인</h1>
        <p class="font-light text-neutral-400 break-keep">
          총회교육개발원 홈페이지에 오신 것을 환영합니다
        </p>
      </div>

      <div class="field_inputs login_inputs max-w-[500px] mx-auto my-10 px-5">
        <div>
          <input
            type="text"
            class="regi_inputs w-full"
            placeholder="아이디"
            v-model="state.form.uid"
          />
        </div>
        <div>
          <input
            type="password"
            class="regi_inputs w-full"
            placeholder="비밀번호"
            v-model="state.form.upw"
            @keyup.enter="submit()"
          />
        </div>

        <div class="flex justify-between mt-4">
          <span class="check_btn check_blk_btn">
            <input id="rememberMe" type="checkbox" name="rememberMe" />
            <label for="rememberMe">아이디 저장</label>
          </span>
          <div class="flex gap-2">
            <a href="" class="text-neutral-400">아이디/비밀번호 찾기</a>
            <router-link to="/signup" class="underline ml-2"
              >회원가입</router-link
            >
          </div>
        </div>

        <div class="mt-8 pb-5">
          <button
            class="sec_filled-blk_btn w-full p-4 disabled:opacity-50 disabled:cursor-not-allowed"
            @click="submit()"
            :disabled="isLoading"
          >
            {{ isLoading ? "로그인 중..." : "로그인" }}
          </button>
        </div>

        <div class="mt-8 pb-10">
          <naverLoginComponent class="w-full !rounded-none mb-2">
            네이버 로그인
          </naverLoginComponent>

          <kakaoLoginComponent class="w-full !rounded-none">
            카카오 로그인
          </kakaoLoginComponent>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { reactive, ref } from "vue";
import axios from "axios";
import store from "@/store";
import router from "@/router";
import { consumeReturnPath } from "@/composables/useAuthReturn";
import naverLoginComponent from "@/components/naverLoginComponent.vue";
import kakaoLoginComponent from "@/components/kakaoLoginComponent.vue";

export default {
  name: "LoginPage",
  components: { naverLoginComponent, kakaoLoginComponent },
  setup() {
    // 상단 로그인 창(components/new/Nav.vue)과 같은 형식으로 보낸다. 일반 로그인의 sns_type 은 빈 값
    const state = reactive({
      form: {
        uid: "",
        upw: "",
        sns_type: "",
      },
    });

    const isLoading = ref(false);

    const validateLoginForm = () => {
      if (!state.form.uid.trim()) {
        alert("아이디를 입력하세요.");
        return false;
      }

      if (!state.form.upw.trim()) {
        alert("비밀번호를 입력하세요.");
        return false;
      }

      return true;
    };

    const submit = async () => {
      if (isLoading.value || !validateLoginForm()) {
        return;
      }

      isLoading.value = true;

      try {
        const { data } = await axios.post("/api/account/login", state.form);

        if (data.err_code === 0) {
          localStorage.setItem("authorization", data.contents.body.accessToken);
          store.commit("setAccount", state.form.uid);

          // 로그인 전에 보던 페이지로 돌아간다 (문자열로 넘겨야 ?q= 같은 쿼리가 유지된다)
          // 뒤로 가기로 로그인 화면에 다시 오지 않도록 기록을 바꿔치운다
          router.replace(consumeReturnPath());
        } else {
          alert(data.err_msg || "로그인에 실패했습니다.");
        }
      } catch (error) {
        if (error.response) {
          const statusCode = error.response.status;
          if (statusCode === 401) {
            alert("아이디 또는 비밀번호를 확인하세요.");
          } else if (statusCode === 500) {
            alert("오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
          } else {
            alert("로그인 중 오류가 발생했습니다.");
          }
        } else {
          alert("네트워크 연결을 확인하고 다시 시도해주세요.");
        }
      } finally {
        isLoading.value = false;
      }
    };

    return { state, isLoading, submit };
  },
};
</script>

<style scoped></style>
